import React, { useEffect, useState } from "react";
import { Row, Col, Container, Accordion, Button } from "react-bootstrap";

import HeadingLines from "../assets/images/heading-lines.svg";
import JobsDetailsImg from "../assets/images/career/document.svg";
import ArrowIcon2 from "../assets/images/blog/arrow-down.svg";
//import { Link } from 'react-router-dom'
//import { Link as ScrollLink } from 'react-scroll'
import CareerForm from "./CareerForm";

import { useDispatch, useSelector } from "react-redux";
import { getJobs } from "../features/career/careerActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { formatDate } from "../helpers/helpers";

function CareerContent() {
  const dispatch = useDispatch();
  const { jobListData, loading } = useSelector((state) => state.career);

  // State to manage pagination
  const [page, setPage] = useState(1);

  // State to store all fetched jobs
  const [allJobs, setAllJobs] = useState([]);

  // visible show more
  const [isVisibleShowMore, setIsVisibleShowMore] = useState(false);

  const [activeKey, setActiveKey] = useState(null);

  // Fetch jobs when the component mounts and reset data
  useEffect(() => {
    let data = { page: page, limit: 3 };
    dispatch(getJobs(data)); // Dispatch to fetch jobs
  }, [dispatch, page]);

  // Handle job list data update
  useEffect(() => {
    if (jobListData?.data !== undefined) {
      setAllJobs((prevJobs) => [...prevJobs, ...jobListData.data]);
      // Check if there are more pages to load
      if (jobListData?.current_page < jobListData?.total_pages) {
        setIsVisibleShowMore(true);
      } else {
        setIsVisibleShowMore(false);
      }
    }
  }, [jobListData]);

  // Load more jobs on "Show More" button click
  const loadMoreJobs = async () => {
    const nextPage = page + 1; // Calculate the next page
    setPage(nextPage); // Update the page number first
  };

  // Function to close all accordions
  const closeAllAccordions = () => {
    setActiveKey(null); // Set to null or '' to close all
  };

  // Reset the state when component mounts or re-mounts
  useEffect(() => {
    // Reset all jobs and page number when component loads
    setAllJobs([]); // Clear all jobs
    setPage(1); // Reset page to 1
    setIsVisibleShowMore(false);
  }, []);

  return (
    <>
      <section className="career-content">
        <Container>
          <Row>
            <Col md="12">
              <div className="common-header">
                <img src={HeadingLines} alt="" />
                <h2>Current Openings</h2>
                <p>We're always looking for talented people</p>
              </div>
              <div className="career-list">
                <Accordion defaultActiveKey="p0" activeKey={activeKey}>
                  {allJobs?.map((job, index) => (
                    <Accordion.Item eventKey={"k" + index} key={index}>
                      <Accordion.Header
                        onClick={() =>
                          setActiveKey(
                            activeKey === "k" + index ? null : "k" + index
                          )
                        }
                      >
                        <div className="opening-header">
                          <div className="opening-text">
                            <h2>{job.job_title}</h2>
                            <div className="jld-group">
                              <p>{job.location}</p>
                            </div>
                          </div>
                          <div className="opening-btn">
                            <p className="jobs-details-btn">
                              <img src={JobsDetailsImg} alt="" /> Job Details
                            </p>
                          </div>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="opening-body">
                          <ul>
                            <li>
                              <span>Date</span>
                              <p>{formatDate(job.created_at)}</p>
                            </li>

                            <li>
                              <span>Location</span>
                              <p>{job.location}</p>
                            </li>

                            <li>
                              <span>Job Type</span>
                              <p>{job.job_type}</p>
                            </li>
                            <li>
                              <span>Experience</span>
                              <p>{job.experience} Years Experience</p>
                            </li>
                            <li>
                              <span>Vacancy</span>
                              <p>{job.no_vacancy} Vacancies</p>
                            </li>
                            <li>
                              <span>Salary</span>
                              <p>{job.salary}</p>
                            </li>
                            <li>
                              <span>Working Hours</span>
                              <p>{job.working_hours} Hours</p>
                            </li>
                            <li>
                              <span>Working Days</span>
                              <p>{job.working_days} Days</p>
                            </li>
                          </ul>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: job.job_description,
                            }}
                          ></div>
                        </div>
                        <CareerForm
                          job={job}
                          closeAllAccordions={closeAllAccordions}
                        />
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            </Col>
          </Row>

          <div className="d-flex justify-content-center mt-5">
            {isVisibleShowMore && (
              <Button
                className="custom-bttn btn-center"
                type="button"
                disabled={loading}
                onClick={loadMoreJobs}
              >
                {loading ? (
                  <FontAwesomeIcon
                    icon={faSpinner}
                    spin
                    size="lg"
                    className="spinner-icon"
                  />
                ) : (
                  <>
                    Show More Jobs <img src={ArrowIcon2} alt="" />
                  </>
                )}
              </Button>
            )}
          </div>
        </Container>
      </section>
    </>
  );
}
export default CareerContent;
